import React from "react";
import { Layout } from "antd";

import "./Layout.scss";

const { Content } = Layout;

const ContentOnly = ({ children }) => {
  return (
    <Layout className="app-layout">
      <Content className="app-layout--content-only">{children}</Content>
    </Layout>
  );
};

export default ContentOnly;
